import * as React from "react";
import type { SVGProps } from "react";
const SvgFileQuestion01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12.6 21.6h-6a2.4 2.4 0 0 1-2.4-2.4V4.8a2.4 2.4 0 0 1 2.4-2.4h10.8a2.4 2.4 0 0 1 2.4 2.4V9M15 15.548c0-1.297 1.075-2.348 2.4-2.348 1.326 0 2.4 1.051 2.4 2.348s-1.074 2.348-2.4 2.348m0 3.194V21"
    />
  </svg>
);
export default SvgFileQuestion01;
